import React from 'react';

import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import AnalysisFlowchart from 'analysis-tool/flowchart/AnalysisFlowchart';

interface AnalysisTemplatePreviewProps {
  templateAnalysis: Pick<AnalysisGraphQL, 'name' | 'execution'> | null;
}

export default function ApplyAnalysisTemplatePreview({
  templateAnalysis,
}: AnalysisTemplatePreviewProps): JSX.Element {
  return templateAnalysis == null ? (
    <div>No template is selected.</div>
  ) : (
    <AnalysisFlowchart analysis={templateAnalysis} isTemplate={true} />
  );
}
